const isFileVideo = file => file && (file.type || '').startsWith('video');

export default isFileVideo;
